/* Action Types */
export const CALL_FETCH_DOCUMENT_TYPES = 'CALL_FETCH_DOCUMENT_TYPES';
export const FETCH_DOCUMENT_TYPES_FAILED = 'FETCH_DOCUMENT_TYPES_FAILED';
export const FETCH_DOCUMENT_TYPES_SUCCESS = 'FETCH_DOCUMENT_TYPES_SUCCESS';
export const TOGGLE_DOCUMENT_TYPE_SELECTION = 'TOGGLE_DOCUMENT_TYPE_SELECTION';

/* Action Creators */
export function fetchDocumentTypes(workflowInstanceId) {
  return { type: CALL_FETCH_DOCUMENT_TYPES, workflowInstanceId };
}

export function fetchDocumentTypesFailed(error) {
  return { type: FETCH_DOCUMENT_TYPES_FAILED, error };
}

export function fetchDocumentTypesSuccess(documentTypes) {
  return { type: FETCH_DOCUMENT_TYPES_SUCCESS, documentTypes };
}

export function toggleDocumentTypeSelection(documentTypeId) {
  return { type: TOGGLE_DOCUMENT_TYPE_SELECTION, documentTypeId };
}

const INITIAL_STATE = {
  data: null,
  errors: {
    fetch: null
  },
  loading: {
    fetch: false
  }
};

export default function reducer(state = INITIAL_STATE, action) {

  const { documentTypeId, documentTypes, error, type } = action;

  switch(type) {
    case CALL_FETCH_DOCUMENT_TYPES:
      return {
        ...state,
        data: [],
        errors: {
          ...state.errors,
          fetch: null,
        },
        loading: {
          ...state.loading,
          fetch: true,
        },
      };
    case FETCH_DOCUMENT_TYPES_FAILED:
      return {
        ...state,
        errors: {
          ...state.errors,
          fetch: error,
        },
        loading: {
          ...state.loading,
          fetch: false,
        },
      };
    case FETCH_DOCUMENT_TYPES_SUCCESS:
      return {
        ...state,
        data:
          documentTypes
            .map(documentType => ({
              ...documentType,
              selected: false
            })),
        errors: {
          ...state.errors,
          fetch: null,
        },
        loading: {
          ...state.loading,
          fetch: false,
        },
      };
    case TOGGLE_DOCUMENT_TYPE_SELECTION:

      const foundDocumentType =
        state.data
          .find(documentType => documentType.id === documentTypeId);

      return {
        ...state,
        data:
          state.data
            .filter(documentType => documentType.id !== documentTypeId)
            .concat([{ ...foundDocumentType, selected: !foundDocumentType.selected }])
      };
    default:
      return state;
  }

}



// WEBPACK FOOTER //
// ./src/ducks/DocumentTypesDucks.js